/* eslint-disable react-hooks/preserve-manual-memoization -- Deliberately narrow deps to avoid unnecessary recalculation */
import { useMemo } from 'react';
import { orderBy } from 'lodash/fp';
import { isNotNullOrUndefined } from '../../utils/isNotNullOrUndefined';
import { useProject } from './useProject';

export const useOrthophotoLayers = () => {
  const { data } = useProject();
  const project = data?.projectById;

  return useMemo(() => {
    const orderedIdentifiers = orderBy('index', 'asc', project?.state.orthophotoLayerOrderedIdentifiers);
    const orthophotoLayers = orderedIdentifiers.map(({ identifier }) => project?.state.orthophotoLayers?.find((layer) => layer.identifier === identifier)).filter(isNotNullOrUndefined);
    return { orthophotoLayers };
  }, [project?.state.orthophotoLayerOrderedIdentifiers, project?.state.orthophotoLayers]);
};
